const createSwiperSlider = sliderElm =>
  new Swiper(sliderElm.querySelector('.swiper'), {
    slideClass: 'card--case',
    slidesPerView: window.innerWidth >= 920 ? 1 : 'auto',
    spaceBetween: sliderElm.querySelectorAll(`.card--case`).length > 1 ? 20 : 0,
    centeredSlides: true,
    effect: window.innerWidth >= 920 ? 'fade' : 'slide',
    pagination: {
      el: sliderElm.querySelector(`.swiper-pagination`),
      clickable: true,
      renderBullet: function (index, className) {
        const title = this.slides[index].dataset.title;
        return `<span class="${className}" tabindex="${index}">${title}</span>`;
      },
    },
  });

const debounce = (func, wait) => {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};

const slidePlatformHome = () => {
  let mySlides = [];

  const init = () => {
    // Destroy existing sliders
    mySlides.forEach(slide => slide.destroy(true, true));
    mySlides = [];
    const contents = document.querySelectorAll('.tabs-slider .tab-view__content');

    contents.forEach(item => (item.style.display = 'block'));

    const allSliders = document.querySelectorAll('.tabs-slider .swiper-container');

    allSliders.forEach(slider => {
      mySlides.push(createSwiperSlider(slider));
    });

    contents.forEach(item => (item.style.display = 'none'));
  };

  const debouncedInit = debounce(init, 300);

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('resize', debouncedInit);
};

slidePlatformHome();
